import React from 'react';
import About from '../../components/about'

export default function Curiosity() {

    return(
        <About />
    )
}